export const SUB_AUTH_STORAGE_KEY = "sub_auth";

const DRAFT_VERSION = 1;

export const AUTH_CODE_VALID_MS = 60 * 60_000;

export type SubscriptionAuthDraft = {
  v: typeof DRAFT_VERSION;
  email: string;
  codeRequested: boolean;
  lastCodeSentToEmail: string;
  resendNotBefore: number;
  validUntil: number;
};

export function readSubscriptionAuthDraft(): SubscriptionAuthDraft | null {
  try {
    const raw = localStorage.getItem(SUB_AUTH_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const d = JSON.parse(raw) as Partial<SubscriptionAuthDraft>;
    if (d.v !== DRAFT_VERSION) {
      clearSubscriptionAuthDraft();
      return null;
    }
    const email = typeof d.email === "string" ? d.email : "";
    const lastCodeSentToEmail = typeof d.lastCodeSentToEmail === "string" ? d.lastCodeSentToEmail : "";
    const validUntil =
      typeof d.validUntil === "number" && Number.isFinite(d.validUntil) ? d.validUntil : 0;
    if (!email || !lastCodeSentToEmail || validUntil <= Date.now()) {
      clearSubscriptionAuthDraft();
      return null;
    }
    const resendNotBefore =
      typeof d.resendNotBefore === "number" && Number.isFinite(d.resendNotBefore) ? d.resendNotBefore : 0;
    return {
      v: DRAFT_VERSION,
      email,
      codeRequested: d.codeRequested === true,
      lastCodeSentToEmail,
      resendNotBefore,
      validUntil,
    };
  } catch {
    clearSubscriptionAuthDraft();
    return null;
  }
}

export function writeSubscriptionAuthDraft(draft: Omit<SubscriptionAuthDraft, "v">): void {
  const payload: SubscriptionAuthDraft = { v: DRAFT_VERSION, ...draft };
  try {
    localStorage.setItem(SUB_AUTH_STORAGE_KEY, JSON.stringify(payload));
  } catch {
  }
}

export function clearSubscriptionAuthDraft(): void {
  try {
    localStorage.removeItem(SUB_AUTH_STORAGE_KEY);
  } catch {
  }
}
